import {
    PayRangeDisplayType,
    CompaRatioDisplayFormat,
    BaseOfCalculation
} from 'typings/enums';
import { action, makeObservable } from 'mobx';

export class PayRangeConfiguration {
    private _showPayRange: boolean;

    private _displayType: PayRangeDisplayType;

    private _compaRatioDisplayFormat: CompaRatioDisplayFormat;

    private _baseOfCalculation: BaseOfCalculation;

    constructor(
        showPayRange: boolean,
        displayType: PayRangeDisplayType,
        compaRatioDisplayFormat: CompaRatioDisplayFormat,
        baseOfCalculation: BaseOfCalculation
    ) {
        makeObservable(this);
        this._showPayRange = showPayRange;
        this._displayType = displayType;
        this._compaRatioDisplayFormat = compaRatioDisplayFormat;
        this._baseOfCalculation = baseOfCalculation;
    }

    get showPayRange(): boolean {
        return this._showPayRange;
    }

    get displayType(): PayRangeDisplayType {
        return this._displayType;
    }

    get baseOfCalculation(): BaseOfCalculation {
        return this._baseOfCalculation;
    }

    get compaRatioDisplayFormat(): CompaRatioDisplayFormat {
        return this._compaRatioDisplayFormat;
    }

    @action
    setShowPayRange(value: boolean): void {
        this._showPayRange = value;
    }

    @action
    setDisplayType(value: PayRangeDisplayType): void {
        this._displayType = value;
    }

    @action
    setCompRatioDisplayFormat(value: CompaRatioDisplayFormat): void {
        this._compaRatioDisplayFormat = value;
    }

    @action
    setBaseOfCalculation(value: BaseOfCalculation): void {
        this._baseOfCalculation = value;
    }
}